import { G } from '@mobily/ts-belt';
import { Box, Carousel, Grid, Placeholder, useScreenSize } from '@stitch-fix/mode-react';
import { TopItemEndCardFragment, TopItemFragment } from '../../../utils/hooks/getTopItems';
import { TopItemEndCard } from './TopItemsEndCard';
import { TopItemsProductCard } from './TopItemsProductCard';
type TopItemsCarouselProps = {
  loading: boolean;
  topItems: TopItemFragment[];
  endCard?: TopItemEndCardFragment;
};

/**
 * Loading state for carousel. Purposely did not use the carousel's children
 * to load placeholders for it causes a weird flaky transition when a client
 * does not have enough top item slides in the carousel. It is safer to use a
 * grid layout as its loading state for now.
 */
const loadingSlides = (numPlaceHolders: number) => {
  const placeholders = [...Array(numPlaceHolders).keys()].map(item => <Placeholder data-testid="top-items-loading-placeholder" variant="rect" width="168px" height="220px" pt="100%" key={`top-items-loading-slides-${item}`} />);
  return <Grid spacing="tight" columns={{
    sm: 3,
    md: 6
  }}>
      {placeholders}
    </Grid>;
};

/**
 * A function creates an array of topItem elements and end card based on the data that comes
 * from the top items query
 */
const getProductCardSlides = (topItems: TopItemFragment[], endCard: TopItemEndCardFragment | undefined) => {
  const productCards = topItems.map(topItem => {
    return <TopItemsProductCard topItem={topItem} key={topItem.skuId} />;
  });
  if (G.isUndefined(endCard)) {
    return productCards;
  }
  return productCards.concat(<TopItemEndCard endCard={endCard} key="top-item-end-card" />);
};

/**
 * The Top Items Carousel renders a Carousel component along with placeholders
 * when it is at the loading state.
 */
export const TopItemsCarousel = ({
  loading,
  topItems,
  endCard
}: TopItemsCarouselProps) => {
  const screenSize = useScreenSize();
  const numPlaceHolders = screenSize === 'sm' ? 3 : 6;
  return <Box my={1}>
      {loading ? loadingSlides(numPlaceHolders) : <Carousel ariaLabel="outfits-carousel" gutterOverflow={{
      sm: 1,
      md: 1.5,
      lg: 0
    }} slideWidth={{
      sm: '170px'
    }}>
          {getProductCardSlides(topItems, endCard)}
        </Carousel>}
    </Box>;
};